export default __webpack_public_path__ + "static/media/app-store-badge.90bc98fb.png";